import {Component} from '@angular/core';
import {LayoutService} from './service/app.layout.service';
import {environment} from "../../environments/environment";
import {GestionDocumentRgpdWVO} from "../components/affichage-cgu/models/GestionDocumentRgpdWVO";
import {AffichageCGUService} from "../components/affichage-cgu/services/affichage-cgu.service";
import packageJson from '../../../package.json';
import { footerService } from '../services/footer.service';
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import { FormGroup } from '@angular/forms';
import { EnvironmentService } from '../services/environment.service';
import { ConfigurationService } from '../services/configuration.service';


@Component({
  selector: 'app-footer',
  templateUrl: './app.footer.component.html'
})
export class AppFooterComponent {
  //get project version
  version :any ;
  footerData: any;
  lienUtile : any;
  reseauSociaux : any;
  mode_avance = this.configurationService.get().FOOTER.MODE_AVANCE;
  companySiteId = this.environmentService.get().companySiteIdentifier;
  hideInfo = false;
  showInfo = false;
  isExpanded = false;
  editForm: FormGroup;
  documents: GestionDocumentRgpdWVO[] = [];
  appVersion: string;
  currentYear: number = new Date().getFullYear();
  hasFooterSpecificLogo =  this.configurationService.get().hasFooterSpecificLogo;

  constructor(public layoutService: LayoutService, private readonly affichageCGUService: AffichageCGUService ,private footerService: footerService,private sanitizer: DomSanitizer, private readonly environmentService: EnvironmentService, private configurationService: ConfigurationService) {
  }

  get footerLogo(): string {
    const baseLogo = this.layoutService.config.colorScheme === 'light' ? 'dark' : 'white';

    if (this.hasFooterSpecificLogo) {
      return `logo-${baseLogo}-footer`;
    } else {
      return `logo-${baseLogo}`;
    }
  }
  ngOnInit() {
    this.showInfo = this.mode_avance ? true : false;
    this.hideInfo = false;
    this.getDocumentsRgpdByCompanySite();
    this.loadFooterContent();
    this.loadAppVersion();
  }



  loadFooterContent() {
    this.footerService?.displayFooter().subscribe(data=> {
      this.footerData=data;
      this.lienUtile =this.footerData.lienUtiles
      this.reseauSociaux = this.footerData.reseauxSociaux;

      },
    )}


    getSortedSocialMediaIcons() {
      const order = ['LINKEDIN', 'YOUTUBE', 'TWITTER', 'INSTAGRAM', 'FACEBOOK'];
      return order.map(key => this.reseauSociaux?.find(reseau => reseau.key === key)).filter(reseau => reseau && reseau.display);
    }


  expandFooter() {
    if (this.mode_avance) {
      this.isExpanded = !this.isExpanded;
      this.hideInfo = true;
      this.showInfo = false;
    } else {
      this.hideInfo = false;
      this.showInfo = false;
    }
  }
  reduireFooter() {
    if (this.mode_avance) {
      this.isExpanded = !this.isExpanded;
      this.hideInfo = false;
      this.showInfo = true;
    } else {
      this.hideInfo = false;
      this.showInfo = false;
    }
  }



  getDocumentsRgpdByCompanySite() {
    this.affichageCGUService.getDocumentsRgpdByCompanySite().subscribe(result => {
      this.documents = result
        .filter(doc => doc.active === undefined || doc.active === true)
            .sort((a, b) => (a.ordre ?? Infinity) - (b.ordre ?? Infinity));
    });
  }

  downloadDocument(document: GestionDocumentRgpdWVO): void {
    this.affichageCGUService.getPdf(document.typeDocument).subscribe((blob: Blob): void => {
      // @ts-ignore
      const file = new Blob([blob], {type: 'application/pdf'});
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL, document.fileName);
    }, error => {
      console.log('document not found')
    });
  }
  scrollToTop() {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }
  renderHtmlContent(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.footerData.corps);
  }

  loadAppVersion() {
    this.footerService.getAppVersion().subscribe(
      version => {
        this.appVersion = 'V ' + version;
      },
    );
  }

}
